import EditOutlined from "@mui/icons-material/EditOutlined";
import { IconButton, Switch, Tooltip } from "@mui/material";
import { type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";

import CoAppDataGridListCell from "../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../global/components/datagrid/CoAppDataGridNameCell";

// `actions` last → row chevron/menu sits on the right edge.
export const pluginColumns = ["name", "groups", "active", "platformName", "actions"];

export interface PluginRow {
	id: string | number;
	name: string;
	groups?: string[];
	platformId?: string | number;
	active?: boolean;
	platformName?: string;
	isCustomerManaged?: boolean;
	[key: string]: unknown;
}

export const getPluginManagementColumns = (
	handlePluginStatusToggleChange: (pluginId: PluginRow["id"], active: boolean, platformId: PluginRow["platformId"]) => void,
	openResourceEditPage: (params: GridRenderCellParams<PluginRow>, navIndex: number, resourceName: string) => void,
	handleOpenResourceHomePage: (navIndex: number, resourceName: string, params: GridRenderCellParams<PluginRow>) => void,
	navigationItemReferences: { pluginNavItemIndex: number } & Record<string, number>
): GridColDef<PluginRow>[] => [
	{
		field: "active",
		headerName: "Status",
		sortable: true,
		width: 90,
		editable: false,
		renderCell: (params: GridRenderCellParams<PluginRow, boolean | undefined>) => (
			<Switch
						checked={Boolean(params.value)}
						onChange={() => handlePluginStatusToggleChange(params.row.id, Boolean(params.value), params.row.platformId)}
						disabled={false}
					/>
		)
	},
	{
		field: "name",
		headerName: "Name",
		flex: 1,
		editable: false,
		sortable: true,
		renderCell: (params: GridRenderCellParams<PluginRow>) => (
			<CoAppDataGridNameCell item={params.row} />
		)
	},
	{
		field: "groups",
		headerName: "Groups",
		sortable: false,
		flex: 1,
		editable: false,
		renderCell: (params: GridRenderCellParams<PluginRow, string[] | undefined>) => (
			<CoAppDataGridListCell items={params.value} resource="Groups" />
		)
	},
	{
		field: "platformName",
		headerName: "Platform",
		flex: 1,
		renderCell: (params: GridRenderCellParams<PluginRow, string | undefined>) => (
			<CoAppDataGridNameCell item={{ name: params.value ?? "" }} />
		)
	},
	{
		field: "actions",
		type: "actions",
		sortable: false,
		flex: .1,
		renderCell: (params: GridRenderCellParams<PluginRow>) => (
			<Tooltip title="Edit plugin" arrow placement="left">
						<IconButton
							size="small"
							onClick={
								!params.row.isCustomerManaged
									?
									() => openResourceEditPage(params, navigationItemReferences.pluginNavItemIndex, "Plugins")
									:
									() => handleOpenResourceHomePage(navigationItemReferences.pluginNavItemIndex, "Plugins", params)
							}
							sx={{
								color: "rgba(13, 31, 48, 0.55)",
								transition: "color 0.15s, background 0.15s",
								"&:hover": {
									color: "var(--coapp-text-interactive, #057A6D)",
									background: "rgba(2, 213, 171, 0.08)"
								}
							}}
						>
							<EditOutlined fontSize="small" />
						</IconButton>
					</Tooltip>
		)
	}
];
